<template>
    <section class="orgAuth">
        <Nav title="机构认证" />
		<section v-if="authStatus==-1"></section>
		<section class="no_over" v-else-if="authStatus==0">
			<div class="form">
				<van-field v-model="orgName" label="认证机构" :left-icon="imgs.companyIcon" placeholder="请输入机构标准全称" readonly /> 
				<div class="upload_card">
					<div class="img_box">
						<div class="img_file">
							<img v-if="OSSLoadingStatus.businessLicense == 0 || OSSLoadingStatus.businessLicense == 3" :src="imgs.renxiangIcon" class="upload_bg">
							<van-loading v-if="OSSLoadingStatus.businessLicense == 1" size="24px" vertical class="oss_loading" color="#fff" text-color="#fff">上传中...</van-loading>
							<img v-if="OSSLoadingStatus.businessLicense == 2" :src="form.businessLicense" class="oss_img">

							<van-icon name="cross" v-if="form.businessLicense" @click="delImg('businessLicense')" />
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange1($event, 'businessLicense')" ref="file1">
						</div>
						<p class="tit">营业执照照片</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="OSSLoadingStatus.logo == 0 || OSSLoadingStatus.logo == 3" :src="imgs.renxiangIcon" class="upload_bg">
							<van-loading v-if="OSSLoadingStatus.logo == 1" size="24px" vertical class="oss_loading" color="#fff" text-color="#fff">上传中...</van-loading>
							<img v-if="OSSLoadingStatus.logo == 2" :src="form.logo" class="oss_img">

							<van-icon name="cross" v-if="form.logo"  @click="delImg('logo')"/>
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange2($event, 'logo')" ref="file2">
						</div>
						<p class="tit">门头Logo照片</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="OSSLoadingStatus.officeEnvironment == 0 || OSSLoadingStatus.officeEnvironment == 3" :src="imgs.shouchiIcon" class="upload_bg">
							<van-loading v-if="OSSLoadingStatus.officeEnvironment == 1" size="24px" vertical class="oss_loading" color="#fff" text-color="#fff">上传中...</van-loading>
							<img v-if="OSSLoadingStatus.officeEnvironment == 2" :src="form.officeEnvironment" class="oss_img">

							<van-icon name="cross" v-if="form.officeEnvironment" @click="delImg('officeEnvironment')" />
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange3($event, 'officeEnvironment')" ref="file3">
						</div>
						<p class="tit">办公环境照片</p>
					</div>
					<div class="img_box" v-if="false">
						<div class="img_file">
							<img v-if="OSSLoadingStatus.officeVideo == 0 || OSSLoadingStatus.officeVideo == 3" :src="imgs.shouchiIcon" class="upload_bg">
							<van-loading v-if="OSSLoadingStatus.officeVideo == 1" size="24px" vertical class="oss_loading" color="#fff" text-color="#fff">上传中...</van-loading>
							<!-- <video v-if="OSSLoadingStatus.officeVideo == 2" :src="form.officeVideo" class="oss_img"></video> -->
							<div v-if="OSSLoadingStatus.officeVideo == 2" class="video_upload_success">上传成功</div>

							<van-icon name="cross" v-if="OSSLoadingStatus.officeVideo == 2" @click="delImg('officeVideo')" />
							<input v-else type="file" accept="video/mp4,video/ogg,video/webm,video/3gpp,video/3gpp2,video/avi,video/mpeg,video/quicktime,video/x-ms-wmv,video/x-msvideo,video/x-flv" @change="fileChange4($event, 'officeVideo')" ref="file4">
						</div>
						<p class="tit">办公环境视频</p>
					</div>
					<div class="img_box">
						<div class="img_file">							
							<img v-if="OSSLoadingStatus.cooperationAgreement == 0 || OSSLoadingStatus.cooperationAgreement == 3" :src="imgs.shouchiIcon" class="upload_bg">
							<van-loading v-if="OSSLoadingStatus.cooperationAgreement == 1" size="24px" vertical class="oss_loading" color="#fff" text-color="#fff">上传中...</van-loading>
							<img v-if="OSSLoadingStatus.cooperationAgreement == 2" :src="form.cooperationAgreement" class="oss_img">

							<van-icon name="cross" v-if="form.cooperationAgreement" @click="delImg('cooperationAgreement')" />
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange5($event, 'cooperationAgreement')" ref="file5">
						</div>
						<p class="tit">持牌机构合作协议</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="OSSLoadingStatus.loanProductInfo == 0 || OSSLoadingStatus.loanProductInfo == 3" :src="imgs.shouchiIcon" class="upload_bg">
							<van-loading v-if="OSSLoadingStatus.loanProductInfo == 1" size="24px" vertical class="oss_loading" color="#fff" text-color="#fff">上传中...</van-loading>
							<img v-if="OSSLoadingStatus.loanProductInfo == 2" :src="form.loanProductInfo" class="oss_img">

							<van-icon name="cross" v-if="form.loanProductInfo" @click="delImg('loanProductInfo')" />
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange6($event, 'loanProductInfo')" ref="file6">
						</div>
						<p class="tit">贷款产品资料</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="OSSLoadingStatus.additionalInfo == 0 || OSSLoadingStatus.additionalInfo == 3" :src="imgs.shouchiIcon" class="upload_bg">
							<van-loading v-if="OSSLoadingStatus.additionalInfo == 1" size="24px" vertical class="oss_loading" color="#fff" text-color="#fff">上传中...</van-loading>
							<img v-if="OSSLoadingStatus.additionalInfo == 2" :src="form.additionalInfo" class="oss_img">

							<van-icon name="cross" v-if="form.additionalInfo" @click="delImg('additionalInfo')" />
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange7($event, 'additionalInfo')" ref="file7">
						</div>
						<p class="tit">其他补充资料（选填）</p>
					</div>
				</div>
			</div>
			<div class="bottom_btn">
				<van-button type="primary" @click="submitForm">提交认证</van-button>
			</div>
		</section>
		<section class="underway" v-else-if="authStatus==1">
			<img src="../../../assets/img/underway.png">
			<p>认证中，1个工作日内完成</p>
		</section>
		<section class="pass" v-else-if="authStatus==2">
			<img src="../../../assets/img/pass.png">
			<p>机构认证通过</p>
		</section>
		<section class="fail" v-else-if="authStatus==3">
			<img src="../../../assets/img/fail.png">
			<p>机构认证失败</p>
			<span v-html="msg" class="msg"></span>
			<van-button round type="danger" class="danger-button" @click="alignFn">重新认证</van-button>
		</section>
	</section>
</template>

<script>

import settingServer from "api/setting";

import Nav from "components/Nav";
import cityIcon from 'assets/img/city.png'
import companyIcon from 'assets/img/company.png'
import cartIcon from 'assets/img/cart.png'
import nameIcon from 'assets/img/name.png'
import gongpaiIcon from 'assets/img/gongpai.png'
import guohuiIcon from 'assets/img/guohui.png'
import shouchiIcon from 'assets/img/shouchi.png'
import renxiangIcon from 'assets/img/renxiang.png'

import { Notify } from 'vant';


export default {
    name: "orgAuth",
    components: {
        Nav,
    },
    data() {
        return {
			authStatus: -1,
			imgs: {
				cityIcon,
				companyIcon,
				cartIcon,
				nameIcon,
				gongpaiIcon,
				guohuiIcon,
				shouchiIcon,
				renxiangIcon,
			},
			form:{
				businessLicense: '',
				logo: '',
				officeEnvironment: '',
				officeVideo: '',
				cooperationAgreement: '',
				loanProductInfo: '',
				additionalInfo: '',
			},
			// 0未上传 1上传中 2上传成功 3上传失败
			OSSLoadingStatus: {
				"businessLicense": 0,
				"logo": 0,
				"officeEnvironment": 0,
				"officeVideo": 0,
				"cooperationAgreement": 0,
				"loanProductInfo": 0,
				"additionalInfo": 0,
			},

			orgName: JSON.parse(localStorage.getItem('accountInfoJSONString')).orgName,
			msg: '',
			canSubmit: true,
		};
    },
    created() {
        this.authStatus = this.$route.params.authStatus
        if (this.authStatus == 3) {
		    this.getInfo()
        }
	},
    methods: {
		getInfo() {
            //获取最新的认证审核记录
			settingServer.getLastestOrgAuthAudit().then((res) => {
				this.msg = res.data.auditOpinion.replace(/\n/g, '<br>')
			})
		},
		alignFn() {
			this.authStatus = 0
		},
		fileChange1 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 1)
		},
		fileChange2 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 2)
		},
		fileChange3 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 3)
		},
		fileChange4 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 4)
		},
		fileChange5 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 5)
		},
		fileChange6 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 6)
		},
		fileChange7 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 7)
		},
		uploadOss(file, type, num) {
			if(file.size/1024/1024>10 && num!=4){
				if(num ==1){
					this.$refs.file1.value = null
				}else if (num == 2) {
					this.$refs.file2.value = null
				}else if (num == 3) {
					this.$refs.file3.value = null
				}else if (num == 4) {
					this.$refs.file4.value = null
				}else if (num == 5) {
					this.$refs.file5.value = null
				}else if (num == 6) {
					this.$refs.file6.value = null
				}else if (num == 7) {
					this.$refs.file7.value = null
				}
				Notify({ type: 'danger', message: '图片不能大于10M' })
				return
			}

			if(file.size/1024/1024>100 && num==4){
				if(num ==1){
					this.$refs.file1.value = null
				}else if (num == 2) {
					this.$refs.file2.value = null
				}else if (num == 3) {
					this.$refs.file3.value = null
				}else if (num == 4) {
					this.$refs.file4.value = null
				}else if (num == 5) {
					this.$refs.file5.value = null
				}else if (num == 6) {
					this.$refs.file6.value = null
				}else if (num == 7) {
					this.$refs.file7.value = null
				}
				Notify({ type: 'danger', message: '视频不能大于100M' })
				return
			}


			let	params = new FormData()
			params.append('file', file)
			this.OSSLoadingStatus[type]=1
			settingServer.upload(params).then((res) => {
				this.OSSLoadingStatus[type]=2
				this.form[type] = res.data
			}).catch((err) => {
				this.OSSLoadingStatus[type]=3
				Notify({ type: 'danger', message: '上传失败：'+err })
			})
		},

		delImg(type) {
			this.form[type]= ''
			this.OSSLoadingStatus[type]=0
		},
		
		submitForm() {
			if(!this.canSubmit) return

			if (!this.form.businessLicense) return Notify({ type: 'warning', message: '请上传营业执照照片' })
			if (!this.form.logo) return Notify({ type: 'warning', message: '请上传门头logo照片' })
			if (!this.form.officeEnvironment) return Notify({ type: 'warning', message: '请上传办公环境照片' })
			// if (!this.form.officeVideo) return Notify({ type: 'warning', message: '请上传办公环境视频' })
			if (!this.form.cooperationAgreement) return Notify({ type: 'warning', message: '请上传持牌机构合作协议照片' })
			if (!this.form.loanProductInfo) return Notify({ type: 'warning', message: '请上传贷款产品资料照片' })

			this.canSubmit = false

			settingServer.orgAuth(this.form).then((res) => {
				this.authStatus = 1
			}).catch(() => {
				this.canSubmit = true
			})
		},

		backFn() {
			this.$router.go(-1)
		},
	},
};
</script>

<style lang="scss">
.orgAuth {
	padding-top: 46px;
	padding-bottom: 80px;
	.no_over {
		.form {
			background: #fff;

			.van-cell {
				align-items: center;
			}

			.van-icon {
				img {
					width: 14px;
				}
			}
			.van-cell__title, .van-field__control {
				color: #2b2f3a;
				font-size: 16px;
			}
			.van-field__label {
				width: 68px;
			}
			.van-icon-arrow {
				color: #575E72;
			}
			.upload_card {
				padding: 19px 18px;
				padding-bottom: 0;
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				.img_box {
					.img_file {
						position: relative;
						width: 159px;
						height: 93px;
					}
					input {
						position: absolute;
						top: 0;
						left: 0;
						z-index: 2;
						width: 100%;
						height: 100%;
						opacity: 0;
					}
					img, video{
						width: 159px;
						height: 93px;
					}
					.oss_img {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
					}
					.oss_loading {
						justify-content: center;
						background-color: rgba(0, 0, 0, 0.7);
						height: 100%;
						color: #fff;
					}
					.upload_bg {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
					}
					.video_upload_success {
						display: flex;
						width: 100%;
						height: 100%;
						justify-content: center;
						align-items: center;
						background-color: rgba(0, 0, 0, 0.7);
						color: #EFF0F4;
						font-size: 14px;
						border-radius: 2%;
					}
					.van-icon {
						position: absolute;
						top: 0;
						right: 0;
						width: 20px;
						height: 20px;
						line-height: 18px;
						padding-left: 6px;
						background-color: rgba(0, 0, 0, 0.7);
						border-radius: 0 0 0 20px;
						color: #fff;
					}
					.tit {
						text-align: center;
						color: #575F72;
						font-size: 15px;
						padding-top: 13px;
						margin-bottom: 26px;
					}
				}
			}
		}
		.authorization {
			font-size: 14px;
			color: #0E88FC;
			padding-left: 19px;
			padding-top: 12px;
		}
		.model_class {
			.van-picker__confirm {
				font-size: 14px;
				color: #2b2f3a;
			}
			.van-hairline--bottom::after {
				border: 0;
			}
			.van-picker__cancel {
				color: #575f72;
			}
		}
		.bottom_btn{
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			.van-button--primary {
				width: 100%;
				height: 56px;
				border-radius: 4px;
				border: 0;
				font-size: 16px;
				font-weight: bold;
				color: #FFFFFF;
				border-radius: 0;
				background: #055ce8;

			}
		}
	}
	.underway {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		img {
			width: 231px;
		}
		p {
			position: absolute;
			bottom: 6px;
			left: 0;
			width: 100%;
			text-align: center;
			font-size: 16px;
			color: #575E72;
		}
	}
	.pass {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 100%;
		text-align: center;
		img {
			width: 157px;
		}
		p {
			color: #2B2F3A;
			font-size: 17px;
			font-weight: bold;
			text-align: center;
			padding-top: 34px;
		}
	}
	.fail {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		text-align: center;
		width: 100%;
		img {
			width: 157px;
		}
		p {
			color: #2B2F3A;
			font-size: 17px;
			font-weight: bold;
			padding-top: 34px;
			width: 80%;
			margin: 0 auto;
		}
		.msg {
			width: 80%;
			display: block;
			margin: 0 auto;
			color: #575F72;
			font-size: 15px;
			padding-top: 4px;
			text-align: left;
			display: flex;
			justify-content: center;
			background: #EFF0F4;
			border-radius: 8px;
			margin-top: 16px;
			padding: 21px 0;
			line-height: 26px;
		}
		.van-button--danger {
			margin-top: 50px;
			width: 217px;
			height: 46px;
			background: #3A5EEC;
			.van-button__text {
				color: #fff;
				padding-top: 0;
				background: transparent;
			}
			
		}

	}

}
</style>


// WEBPACK FOOTER //
// src/views/setting/auth/OrgAuth.vue